import React, { useCallback, useState } from "react";
import { observer } from "mobx-react-lite";
import { TextArea } from "../TextArea";
import { useFormContext } from "../Form";
export var PlainTextEditor = observer(function (_a) {
    var _b;
    var name = _a.name, customControls = _a.customControls, onChange = _a.onChange, onBlur = _a.onBlur;
    var _c = useState({ start: 0, end: 0 }), selection = _c[0], setSelection = _c[1];
    var values = useFormContext().values;
    var editorElement = {
        selection: {
            focus: function () { },
            insertHTML: function (text) {
                if (selection.start === null || selection.end === null)
                    return;
                var currentText = values[name];
                var left = currentText.substring(0, selection.start);
                var right = currentText.substring(selection.end, currentText.length);
                var newText = "".concat(left).concat(text).concat(right);
                values.set(name, newText);
                setSelection({ start: left.length, end: left.length + text.length });
            },
        },
    };
    var onTextAreaChange = useCallback(function (e) {
        setSelection({
            start: e.target.selectionStart,
            end: e.target.selectionEnd,
        });
    }, []);
    var onTextAreaBlur = useCallback(function (e) {
        setSelection({
            start: e.target.selectionStart,
            end: e.target.selectionEnd,
        });
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "jodit-container jodit jodit_theme_piston" },
            React.createElement("div", { className: "jodit-toolbar__box" },
                React.createElement("div", { className: "jodit-toolbar-editor-collection jodit-toolbar-editor-collection_mode_horizontal jodit-toolbar-editor-collection_size_middle" },
                    React.createElement("div", { className: "jodit-ui-group jodit-ui-group_line_true jodit-ui-group_size_middle" },
                        React.createElement("div", { className: "jodit-ui-group jodit-ui-group_size_middle" },
                            React.createElement("span", { className: "jodit-toolbar-button jodit-toolbar-button_size_middle jodit-toolbar-button_variant_initial jodit-toolbar-button_M jodit-toolbar-button_text-icons_true jodit-ui-group__M", role: "listitem" }, customControls.map(function (c) { return (React.createElement("button", { className: "jodit-toolbar-button__button", type: "button", onClick: function () { return c.onClick(editorElement); }, key: c.name },
                                React.createElement("span", { className: "jodit-toolbar-button__text" }, c.label))); })))))),
            React.createElement("div", { className: "jodit-workplace" },
                React.createElement(TextArea, { label: "", name: name, style: {
                        backgroundColor: "#fff",
                        color: "#111",
                        padding: "10px",
                        maxWidth: "100%",
                        minWidth: "100%",
                    }, onChange: onChange, onBlur: onBlur, rawOnChange: onTextAreaChange, rawOnBlur: onTextAreaBlur })),
            React.createElement("div", { className: "jodit-status-bar" },
                React.createElement("div", { className: "jodit-status-bar__item jodit-status-bar__item-right" }, values && values[name] !== null && (React.createElement("span", null,
                    "Chars: ", (_b = values[name]) === null || _b === void 0 ? void 0 :
                    _b.length)))))));
});
